<svg viewBox="0 0 24 24" 
    xmlns="http://www.w3.org/2000/svg">
    <path fill="currentColor" d="M22 17.375l-7.128-5.346L12 14.12l-2.872-2.09L2 17.375V18h20v-.625zm0-1.25v-9.28l-6.281 4.569L22 16.125zm-20 0l6.281-4.711L2 6.846v9.279zM2 5.609l10 7.273 10-7.273V5H2v.609zM2 3h20a2 2 0 0 1 2 2v13a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z"/>
</svg>
